import { defineStore } from 'pinia'
import { IAppState } from './app.types'

export const useAppStore = defineStore('app', {
  state: (): IAppState => ({
    autoRefreshDataPingInMS: 19000,
    isLoading: false,
    accountID: 0,
    notificationIntervalID: null,
    itemEventForLinkedTaskID: null,
    error: null,
    lastVisitedBreadcrumbDataFromListing: null,
    lastVisitedBreadcrumbItemMenuItems: null,
    lastVisitedEntityLandingMemberData: null,
  }),
})
